import React from "react";
import { Paper, Box, Typography, IconButton } from "@mui/material";
import { Layers as LayersIcon, Pencil as PencilIcon, Trash as TrashIcon, ChevronRight as ChevronRightIcon } from "lucide-react";

const CourseletItem = ({ courselet, onSelectCourselet, onEdit, onDelete }) => {
  // Clicking the card (or the view icon) will trigger onSelectCourselet.
  const handleSelect = (e) => {
    onSelectCourselet(courselet._id);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    if (onEdit) onEdit(courselet);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) onDelete(courselet);
  };

  const handleView = (e) => {
    e.stopPropagation();
    onSelectCourselet(courselet._id);
  };

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        mb: 1,
        borderRadius: 2,
        cursor: 'pointer',
        transition: 'all 0.2s',
        borderLeft: 'none',
        background: 'white',
        '&:hover': {
          bgcolor: '#f5f5f5'
        }
      }}
      onClick={handleSelect}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <LayersIcon size={18} color="#1976d2" style={{ marginRight: 8 }} />
            <Typography variant="subtitle1" fontWeight="medium">
              #{courselet.order} {courselet.title}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {courselet.domain}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex' }}>
          <IconButton size="small" color="primary" onClick={handleEdit} title="Edit Courselet">
            <PencilIcon size={16} />
          </IconButton>
          <IconButton size="small" color="error" onClick={handleDelete} title="Delete Courselet">
            <TrashIcon size={16} />
          </IconButton>
          <IconButton size="small" color="primary" onClick={handleView} title="View Courselet">
            <ChevronRightIcon size={16} />
          </IconButton>
        </Box>
      </Box>
    </Paper>
  );
};

export default CourseletItem;
